import React from 'react';

import { CandidatesWithPosition } from '@types';
import { RecommendedStar } from 'components/common/RecommendedStar/RecommendedStar';

import { PersonNameCell } from './PersonNameCell';

export const CandidateNameCell: React.FC<{
  candidate: CandidatesWithPosition;
  positionName?: string;
  withRegion?: boolean;
}> = ({ candidate, positionName, withRegion = true }) => (
  <PersonNameCell
    name={`${candidate.firstName} ${candidate.lastName}`}
    country={candidate.country}
    seniority={candidate.seniority}
    mark={Boolean(candidate.isStarred) && <RecommendedStar />}
    subtitle={positionName}
    withRegion={withRegion}
  />
);
